/** GA4 item-scoped `gender` parametresi için cinsiyet türetimi.
 *
 *  DİKKAT: Ürün detay API'si cinsiyet DÖNDÜRMÜYOR — `/products/slug/{slug}`
 *  yanıtında gender/gender_id/gender_name alanı yok, `category_breadcrump` de
 *  boş (level_01..03 = null) geliyor. Bu yüzden değer kategori slug'larından
 *  türetiliyor; kalıcı çözüm backend'in ürün yanıtına gender eklemesidir.
 *
 *  Tanınmayan taksonomide bilinçli olarak `undefined` döner: GA4'e yanlış
 *  cinsiyet göndermektense parametreyi hiç göndermemek doğrudur. */

const RULES: { match: RegExp; value: string }[] = [
  { match: /(^|-)kadin(-|$)/, value: "Kadın" },
  { match: /(^|-)erkek(-|$)/, value: "Erkek" },
  // "cocuk", "kiz-cocuk", "erkek-cocuk" → Çocuk (erkek kuralından önce gelmeli
  // diye değil; erkek-cocuk için ikisi de eşleşir, çocuk daha spesifik olduğu
  // için listede önce kontrol edilir).
  { match: /cocuk/, value: "Çocuk" },
  { match: /unisex/, value: "Unisex" },
  { match: /tesettur/, value: "Kadın" },
];

/** Öncelik: en spesifik kategori → en genel. İlk eşleşen kazanır. */
export const resolveGender = (
  ...slugs: (string | null | undefined)[]
): string | undefined => {
  const haystack = slugs.filter(Boolean).map((s) => s!.toLowerCase());
  // Çocuk kuralı, "erkek-cocuk" gibi birleşik slug'larda erkek'i ezmeli.
  const child = haystack.some((s) => /cocuk/.test(s));
  if (child) return "Çocuk";

  for (const slug of haystack) {
    for (const rule of RULES) {
      if (rule.match.test(slug)) return rule.value;
    }
  }
  return undefined;
};
